import { useRouter } from "next/router";
import React from "react";

import MenuBoxLink from "@/components/atoms/link/MenuBoxLink";
import { MypageMenu } from "@/models/mypage/mypage";
import { useLogout } from "@/states/auth/operations";
import { useLoading } from "@/states/loading/operations";

interface Props {
  menus: MypageMenu[];
}
const MY_PAGE_PATH = "/mypage";

export default function MenuLinkList({ menus }: Props) {
  const router = useRouter();
  const logout = useLogout();
  const withLoading = useLoading();

  const handleLogout = async () => {
    await withLoading(async () => {
      await logout();
    });
  };

  return (
    <>
      <nav className="w-full h-full">
        <ul className="">
          {menus.map((menu, i) => (
            <li key={i}>
              <MenuBoxLink
                href={menu.href}
                current={checkCurrentPath(router.asPath, menu.href)}
              >
                {menu.text}
              </MenuBoxLink>
            </li>
          ))}
          <li className="mt-2">
            <a
              onClick={() => void handleLogout()}
              className="flex flex-row items-center p-2 text-sm hover:bg-neutral-300 focus:bg-neutral-300 cursor-pointer"
            >
              <div className="self-stretch border border-transparent"></div>
              <div className="pl-2 space-y-1">ログアウト</div>
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
}

/**
 * 現在のパスチェック
 * mypageのみ完全一致でそれ以外のページは前方一致だとtrue
 * @param routerPath
 * @param menuPath
 * @returns
 */
const checkCurrentPath = (routerPath: string, menuPath: string) => {
  if (routerPath === MY_PAGE_PATH && menuPath === MY_PAGE_PATH) {
    return true;
  } else if (
    menuPath !== MY_PAGE_PATH &&
    decodeURI(routerPath).startsWith(menuPath)
  ) {
    return true;
  }
  return false;
};
